import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
function CareerDetails7() {
return (
<> 
  <Header />

  <section className="container" style={{ paddingTop: "120px" }}>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        marginBottom: "40px",
      }}
    >
      <div
        style={{
          width: "300px",
          height: "1px",
          backgroundColor: "#dcdcdc",
        }}
      ></div>

      <p
        style={{
          margin: 0,
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link to="/" style={{ color: "#111", textDecoration: "none" }}>
          Home
        </Link>

        {" / "}

        <Link
          to="/careers"
          style={{ color: "#111", textDecoration: "none" }}
        >
          Careers
        </Link>

        {" / "} Creative Strategist
      </p>
    </div>

    <h1
      style={{
        textAlign: "center",
        fontSize: "64px",
        lineHeight: "1.1",
        marginBottom: "80px",
      }}
    >
      <span style={{ fontWeight: "600" }}>
        Creative
      </span>{" "}
      <span style={{ fontWeight: "300" }}>
        Strategist
      </span>
    </h1>

    <div style={{ maxWidth: "720px", margin: "0 auto" }}>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Position:</strong> Creative Strategist
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Job ID:</strong> BNWJB20260129
      </p>

      <p style={{ marginBottom: "15px", fontSize: "16px" }}>
        <strong>Employment Type:</strong> Full Time (Remote)
      </p>

      <p style={{ marginBottom: "40px", fontSize: "16px" }}>
        <strong>Experience:</strong> 5 to 8 Years
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        About the Role
      </h4>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "40px",
        }}
      >
        We are looking for a highly driven and insightful-led Creative
        Strategist with 5–8 years of experience in branding, advertising,
        or integrated marketing. This role bridges the gap between business
        objectives and creative execution. You will be responsible for
        transforming research, market insights, and cultural understanding
        into powerful brand narratives and campaign directions.
      </p>

      <p
        style={{
          fontSize: "16px",
          lineHeight: "1.8",
          color: "#777",
          marginBottom: "40px",
        }}
      >
        The ideal candidate combines analytical thinking with creative
        instinct — someone who understands consumer behavior, identifies
        opportunities, and shapes compelling brand stories that drive
        impact across platforms.
      </p>

      <h4 style={{ marginBottom: "25px" }}>
        Key Responsibilities
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>Develop comprehensive brand and campaign strategies aligned with business goals.</li>
        <li>Translate market research, audience insights, and data into actionable creative briefs.</li>
        <li>Lead strategic thinking for brand positioning, naming, identity systems, communication frameworks, and campaign concepts.</li>
        <li>Collaborate closely with designers, copywriters, digital teams, and account managers to ensure strategic clarity across executions.</li>
        <li>Conduct competitive audits, consumer behavior studies, and cultural trend analysis.</li>
        <li>Define brand voice, messaging architecture, and storytelling frameworks.</li>
        <li>Present strategic recommendations confidently to internal teams and clients.</li>
        <li>Guide integrated campaigns across digital, print, social, experiential, and performance marketing channels.</li>
        <li>Ensure brand consistency across all touchpoints and communication platforms.</li>
        <li>Evaluate campaign effectiveness and optimize strategy based on performance insights.</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        Required Skills & Qualifications
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>5–8 years of experience in a creative agency, branding firm, or marketing-led organization.</li>
        <li>Strong portfolio demonstrating strategic thinking across brand and campaign projects.</li>
        <li>Deep understanding of brand development, positioning, and consumer psychology.</li>
        <li>Proven experience in writing strategic briefs and communication frameworks.</li>
        <li>Ability to connect cultural insights with business opportunities.</li>
        <li>Strong presentation and storytelling skills.</li>
        <li>Experience working on multi-channel campaigns.</li>
        <li>Excellent research, analytical, and problem-solving capabilities.</li>
        <li>Strong collaboration skills with cross-functional creative teams.</li>
        <li>Ability to manage multiple projects and meet deadlines in a fast-paced environment.</li>
      </ul>

      <h4 style={{ marginBottom: "25px" }}>
        What We're Looking For
      </h4>

      <ul
        style={{
          color: "#777",
          fontSize: "16px",
          lineHeight: "2",
          marginBottom: "40px",
        }}
      >
        <li>A thinker who challenges assumptions and pushes creative boundaries.</li>
        <li>Someone who sees patterns in culture, behavior, and business.</li>
        <li>A strong communicator who can articulate ideas with clarity and conviction.</li>
        <li>A strategic mind with a strong aesthetic sensibility.</li>
        <li>A self-starter with ownership mindset and leadership qualities.</li>
      </ul>

    <hr
  style={{
    border: "none",
    borderTop: "1px solid #ddd",
    marginTop: "60px",
    marginBottom: "30px",
  }}
/>

<div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "50px",
  }}
>
  <Link
    to="/apply-job"
    style={{
      textDecoration: "none",
      color: "#111",
      fontSize: "16px",
      fontWeight: "500",
    }}
  >
    Apply
  </Link>

  <Link
    to="/apply-job"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "22px",
    }}
  >
    →
  </Link>
</div>

    </div>
  </section>

  <Footer />
</>

);
}

export default CareerDetails7;